<template lang="pug">
	.step
		.step__title
			|Программа - {{getSelectedProgramTitle}}
		.step__subtitle
			|Страхователь (будет застрахован):
		.step__list
			.step__item.step__item_large
				//- .step__item-left
					//- .step__pic
						img.step__pic-elem(src="img/name.svg")
				.step__item-right
					.input
						//- Vue-suggestions(:model.sync="insurerName", :placeholder="'Фамилия Имя Отчество'", class="input__control", :options="suggestionOptions")
						app-input(:input="schema.insurerName", :field.sync="insurerName")
					//- app-suggestion(:input="schema.insurerName", @handleInput="handleInputName", :model.sync="insurerName",:options="suggestionOptions")
					//- input.input__control
					//- app-input(:input="schema.insurerName", :field.sync="insurerName")

			.step__item.step__item_small
				//- .step__item-left
					.step__pic
						img.step__pic-elem(src="img/monthly_calendar.svg")
				.step__item-right
					app-input(:input="schema.birthDate", :field.sync="birthDate")
			.step__item
				//- .step__item-left
					.step__pic
						img.step__pic-elem(src="img/passport.svg")
				.step__item-right
					app-input(:input="schema.phone", :field.sync="phone")
					//- app-input(:input="schema.passport", :field.sync="passport", @handleInput="handleInput")
			.step__item
				//- .step__item-left
					.step__pic
						img.step__pic-elem(src="img/address.svg")
				.step__item-right
					app-input(:input="schema.mail", :field.sync="mail")
					//- app-suggestion(:input="schema.address", :model.sync="address", :coordinates.sync="coordinates", :options="suggestionOptionsAddress")
					//- app-input(:input="schema.address", :field.sync="address")
			.step__item.step__item_small
				//- .step__item-left
					.step__pic
						img.step__pic-elem(src="img/passport.svg")
				.step__item-right
					app-input(:input="schema.passport", :field.sync="passport")
			.step__item.step__item_large
				//- .step__item-left
					.step__pic
						img.step__pic-elem(src="img/address.svg")
				.step__item-right
					app-input(:input="schema.address", :field.sync="address")
					//- app-input(:input="schema.mail", @handleInput="handleInput", :field.sync="mail")
					//- app-suggestion(:input="schema.address", :model.sync="address", :coordinates.sync="coordinates", :options="suggestionOptionsAddress")
					
		template(v-if="selectedProgram == 'family' || selectedProgram == 'family-prem'")
			.step__subtitle
				|Застрахованные члены семьи:
			.step__list.step__list_bottom
				.step__item-title
						|2 застрахованный - взрослый
				.step__item.step__item_large
					.step__item-right
						app-input(:input="schema.adultName", :field.sync="adult.name")
				.step__item.step__item_small
					.step__item-right
						app-input(:input="schema.adultBirthDate", :field.sync="adult.date")
				template(v-for="(item, index) in insuredChildren")
					.step__item-title
						|{{index+3}} застрахованный - ребенок
					.step__item.step__item_large
						.step__item-right
							app-input(:input="schema.insuredPeopleName", :index="index", :field.sync="item.name")
					.step__item.step__item_small
						.step__item-right
							app-input(:input="schema.insuredPeopleBirthDate", :index="index", :field.sync="item.date")
		
		.step__button(v-if="selectedProgram == 'family' || selectedProgram == 'family-prem'")
			a.button.button_type-simple.button_add(v-if="insuredChildren.length > 1", href="#",  @click.prevent="removeChild")
				|Удалить
			a.button.button_secondary.button_add(v-if="insuredChildren.length < 10 || insuredChildren.length < 10", href="#", @click.prevent="addChild")
				|Добавить ребенка
		app-popup(v-if="popupIsActive")
			.popup-content
				.popup-content__title
					|Произошла ошибка
				.popup-content__text
					|К сожалению, в данный момент оформление полиса онлайн невозможно из-за непредвиденной ошибки. Мы приносим свои извинения.
				.popup-content__footer
					a.popup-content__link(href="https://zettains.ru/")
						|Вернуться на главную страницу
</template>

<script>
// @ is an alias to /src
import AppInput from '@/components/Input.vue'
import AppPopup from '@/components/Popup.vue'
import AppSuggestion from '@/components/Suggestion.vue'
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
// import VueSuggestions from 'vue-suggestions';
export default {
	inject: ['$validator'],
	name: 'app-step2',
	components: {
		AppInput,
		AppSuggestion,
		AppPopup
		// VueSuggestions
	},
	data() {
		return {
			coordinates: {
				latitude: '',
				longitude: ''
			},
			suggestionOptions: {
				token: 'b8d2f46af618999745d21cbcc963c514a5ab7d7c',
				type: "NAME",
				scrollOnFocus: false,
				triggerSelectOnBlur: true,
				triggerSelectOnEnter: false,
				addon: 'none',
				onSelect: (suggestion) => {
					this.insurerGender = suggestion.data.gender[0].toLowerCase()
					// this.insurerName = `${suggestion.data.surname} ${suggestion.data.name} ${suggestion.data.patronymic}`
				},
				onSelectNothing(suggestion){
					// console.log('nothing', suggestion, this)
					// this.insurerName = '';
					this.value = '';
				}
			},
			suggestionOptionsAddress: {
				// @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
				token: 'b8d2f46af618999745d21cbcc963c514a5ab7d7c',
				type: "ADDRESS",
				scrollOnFocus: false,
				triggerSelectOnBlur: true,
				triggerSelectOnEnter: false,
				addon: 'none',
				// @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
				onSelect (suggestion) {
					// console.log('selected',suggestion, this)
				},
				onSelectNothing(suggestion){
					// console.log('nothing', suggestion)
					// this.address = '';
					this.value = '';
					// console.log(this.nextSibling)
				}
			},
		}
	},
	methods:{
		addChild(){
			if(this.insuredChildren.length >=10) {
				return
			}
			this.insuredChildren.push({
				name:'',
        date:''
			})
			// this.$validator.validate().then(valid => {
			// 	if (valid) {

			// 	}
			// });
		},
		removeChild(){
				this.insuredChildren.pop()
		},
		handleInputName(e){
			
			// console.log('eee', this.insurerName)
		},
		handleClickPrev(){
			this.$router.push({name:'step1'})
		},
		handleInput(e){
		
		}
	},
	computed:{
		...mapFields([
			'insurerName',
			'birthDate',
			'phone',
			'mail',
			'passport',
			'address',
			// 'insuredPeople',
			'selectedProgram',
			'programms',
			'adult',
			'insuredChildren',
			'popupIsActive',
			// 'insurerGender',
		]),
		...mapGetters({
			schema: 'getSchema',
			// popupIsActive: 'PopupIsActive'
		}),
		getSelectedProgramTitle(){
			return this.programms.find(item => item.value == this.selectedProgram).text
		},
	}

}

</script>

<style lang="scss">


</style>
